import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPushSubscriptionState, getPushSubscriptions } from './selectors';
import {
  togglePushSubscription,
  updatePushSubscriptions,
  displayPushNotificationsModal,
} from './actions';
import { PushSubscriptionState, PushSubscriptions } from './types';
import { useAction } from '@wix/da-hooks/pkg/useAction';

export function usePushSubscription() {
  const state = useSelector(getPushSubscriptionState);

  return {
    state,
    isBlocked:
      typeof window !== 'undefined' &&
      window.Notification &&
      window.Notification.permission === 'denied',
    isSubscribed: state === PushSubscriptionState.SUBSCRIBED,
    canToggle: [
      PushSubscriptionState.SUBSCRIBED,
      PushSubscriptionState.READY_TO_SUBSCRIBE,
    ].includes(state),
    toggle: useAction(togglePushSubscription),
    manage: useAction(displayPushNotificationsModal),
  };
}

// get a PushSubscriptions map to see which notifications the user subscribed to
export function usePushSubscriptions() {
  const dispatch = useDispatch();
  const subscriptions = useSelector(getPushSubscriptions);
  const setSubscriptions = useCallback(
    (updatedSubscriptions: Partial<PushSubscriptions>) => {
      dispatch(updatePushSubscriptions(updatedSubscriptions));
    },
    [dispatch]
  );

  return [subscriptions, setSubscriptions] as const;
}
